module.exports = ".form-group {\n  min-width: 300px;\n  padding-right: 15px; }\n  .form-group .form-field {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/submission/components/add-vocabulary-mapping-dialog.component.scss
// module id = ./src/app/submission/components/add-vocabulary-mapping-dialog.component.scss
// module chunks = main